/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.timeSavedContent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
}

.timeSavedHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.timeSavedTitle {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.timeSavedTitle.bold,
.timeSavedTitle .bold {
  font-weight: 600;
}
.timeSavedTitle {
  font-weight: 600;
}

.timeSavedValue {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.timeSavedValue.bold,
.timeSavedValue .bold {
  font-weight: 600;
}
.timeSavedValue {
  font-weight: 600;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */